import AjaxService from "../../platform/ajax/AjaxService";

export const callApiUpdateOptiselEventNote = (eventId: string, note: string): Promise<{ note: string }> =>
    AjaxService.postJson(
        `/api/optisel-event/${eventId}/update-note?note=${encodeURIComponent(note)}`,
        {}
    ).then(response => response.json as { note: string });
